module.exports = "/_next/static/images/platform_7-334cd8368639bd5ecb6fb4660be76bfe.png";